<template>
  <el-popover :placement="placement" width="400" trigger="click" style="padding: 0 !important;">
    <div class="format-help-popover-header el-card__header">
      <span>{{ $t('refCodeFormattingHelp') }}</span>
    </div>
    <div class="format-help-popover-body">
      <el-row class="format-help-popover-body-item">
        <el-col :span="11" class="text-right">
          <el-tag effect="dark" class="format-help">${START_YY}</el-tag>
        </el-col>
        <el-col :span="13" class="format-help-description">{{ $t('yearOfStartValidContract') }}</el-col>
      </el-row>
      <el-row class="format-help-popover-body-item">
        <el-col :span="11" class="text-right">
          <el-tag effect="dark" class="format-help">${END_YY}</el-tag>
        </el-col>
        <el-col :span="13" class="format-help-description">{{ $t('yearOfEndValidContract') }}</el-col>
      </el-row>
      <el-row class="format-help-popover-body-item"
              v-if="isContractRefCode">
        <el-col :span="11" class="text-right">
          <el-tag effect="dark" class="format-help">${RATECODE}</el-tag>
        </el-col>
        <el-col :span="13" class="format-help-description">{{ $t('rateCode') }}</el-col>
      </el-row>
      <el-row class="format-help-popover-body-item"
              v-if="isSpecialOfferRefCode">
        <el-col :span="11" class="text-right">
          <el-tag effect="dark" class="format-help">${PROMOTION_CODE}</el-tag>
        </el-col>
        <el-col :span="13" class="format-help-description">{{ $t('promotionCode') }}</el-col>
      </el-row>
      <el-row class="format-help-popover-body-item">
        <el-col :span="11" class="text-right">
          <el-tag effect="dark" class="format-help">${ALLOT_TYPE}</el-tag>
        </el-col>
        <el-col :span="13" class="format-help-description">
          <div>{{ $t('allotmentType') }}</div>
          <div>- <b>ALT</b> = {{ $t('allotment') }}</div>
          <div>- <b>NOALT</b> = {{ $t('noAllotment') }}</div>
        </el-col>
      </el-row>
      <el-row class="format-help-popover-body-item">
        <el-col :span="11" class="text-right">
          <el-tag effect="dark" class="format-help">${MARKET}</el-tag>
        </el-col>
        <el-col :span="13" class="format-help-description">{{ $t('agentMarketName') }}</el-col>
      </el-row>
      <el-row class="format-help-popover-body-item">
        <el-col :span="11" class="text-right">
          <el-tag effect="dark" class="format-help">${HOTEL_CODE}</el-tag>
        </el-col>
        <el-col :span="13" class="format-help-description">{{ $t('hotelCode') }}</el-col>
      </el-row>
      <el-row class="format-help-popover-body-item" v-if="isContractRefCode">
        <el-col :span="11" class="text-right">
          <el-tag effect="dark" class="format-help">${AGENT}</el-tag>
        </el-col>
        <el-col :span="13" class="format-help-description">{{ $t('agentName') }}</el-col>
      </el-row>
    </div>
    <i v-if="buttonType === 'icon'" class="el-icon-info btn-icon-info" slot="reference"></i>
    <el-button v-if="buttonType === 'button'"
               :size="buttonSize"
               type="primary"
               slot="reference"
               style="margin-left: 10px" plain>
      {{ $t('formattingHelp') }}
    </el-button>
  </el-popover>
</template>

<script>
import i18nMessages from '@/translations/Setting/ManageSetting/General/components/RefCodeFormattingHelpComponent.i18n'

export default {
  name: 'RefCodeFormattingHelpComponent',
  i18n: { messages: i18nMessages },
  props: {
    buttonSize: {
      type: String,
      default: ''
    },
    placement: {
      type: String,
      default: 'top'
    },
    buttonType: {
      type: String,
      default: 'button'
    },
    isContractRefCode: {
      type: Boolean,
      default: true
    },
    isSpecialOfferRefCode: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
  .format-help-popover-header {
    padding: 10px;
    border-bottom: 1px solid #EBEEF5;
    font-size: 15px;
    background-color: #f8f9fa;
  }

  .format-help-popover-body {
    padding: 10px;
  }

  .format-help-popover-body-item {
    margin: 10px 0;
  }

  .format-help {
    border-radius: 15px;
    margin-right: 30px;
  }

  .format-help-description {
    line-height: 30px;
  }

  .btn-icon-info {
    margin-left: 5px;
    color: #409eff;
    font-size: 20px;
    cursor: pointer;
  }
</style>
